import React from 'react';
import { useParams } from 'react-router-dom';
import DataTableV3 from 'src/components/DataTableV3';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { DataTableV3Ids } from 'src/constants/dataTableIds';
import { useFundsOverviewColumns } from '../hooks/use-funds-overview-columns';
import { useAdminEsaOverview } from '../hooks/use-admin-esa-overview';
const Overview = () => {
  const { year } = useParams();
  const { adminEsaData } = useAdminEsaOverview(parseInt(year as string));
  const columns = useFundsOverviewColumns();
  return (
    <ContentPage title={`Tildelte midler ${year}`}>
      <DataTableV3 columns={columns} data={adminEsaData} id={DataTableV3Ids.SivaAdmin.FundsOverview} />
    </ContentPage>
  );
};
export default Overview;
